export { default } from './AppRegistrationSuccess';
